import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import Button from 'components/common/Button';
import InputField from 'components/Credit24/Core/Controls/InputField';

const propTypes = {
  isLoading: PropTypes.bool,
  migrationFailed: PropTypes.bool,
  isOcm: PropTypes.bool,
};

const whatsNextItems = ['selectEmail', 'putEmail', 'verifyEmail'];

const Welcome = (props) => {
  const { isLoading, isOcm } = props;
  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id="migration.welcome.title" />
      </h1>
      <div className="loan-form__step-body">
        <FormattedMessage id="migration.welcome.text" tagName="p" />
        <FormattedMessage id="migration.welcome.subtitle" tagName="h3" />
        <ul>
          {whatsNextItems.map((item) => (
            <FormattedMessage id={`migration.welcome.next.${item}`} tagName="li" key={item} />
          ))}
        </ul>
        <br />
        {props.migrationFailed
          && (
          <div className="message message--error">
            <span className="message__icon" />
            <div className="message__content">
              {isOcm ? (
                <FormattedMessage id="ocm.welcome.error" />
              ) : (
                <FormattedMessage id="migration.welcome.error" />
              )}
            </div>
          </div>
          )}
        <div className="grid grid--center">
          <div className="grid__item one-half palm-one-whole">
            <Field
              title={<FormattedMessage id="registration.field.email" />}
              name="email"
              type="email"
              component={InputField}
              disabled={isLoading}
              isFullWidth
              isErrorVisible
              hintConfig={{ titleKey: 'registration.field.email.hint' }}
            />
          </div>
          <div className="grid__item one-half palm-one-whole">
            <Field
              title={<FormattedMessage id="migration.welcome.field.emailConfirm" />}
              name="emailConfirm"
              type="email"
              component={InputField}
              disabled={isLoading}
              isFullWidth
              isErrorVisible
            />
          </div>
          <div className="grid__item one-quarter lap-one-third palm-one-whole">
            <Button
              isLoading={isLoading}
              disabled={isLoading}
              isFullWidth
            >
              <FormattedMessage id="migration.welcome.submit" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

Welcome.propTypes = propTypes;

export default Welcome;
